import { useEffect } from "react";
import { useLang } from "../context/LanguageContext";

const SITE = "HAAS Mosaic";

const setMeta = (key, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = () => {
  const href = window.location.origin + window.location.pathname;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * useSeo({ title, description })
 * title & description can be plain strings or bilingual objects {en, tr}
 */
export const useSeo = ({ title, description } = {}) => {
  const { tr, lang } = useLang();
  useEffect(() => {
    const t = tr(title);
    const d = tr(description);
    const fullTitle = t ? `${t} | ${SITE}` : `${SITE} | El Yapımı Mozaik Sanatı`;
    document.title = fullTitle;
    setMeta("og:title", fullTitle, "property");
    if (d) {
      setMeta("description", d);
      setMeta("og:description", d, "property");
    }
    setMeta("og:url", window.location.href, "property");
    setCanonical();
    document.documentElement.lang = lang;
  }, [title, description, lang, tr]);
};

export default useSeo;
